/**
 * #day3 - Material Spinner
 */

export const MaterialSpinnerOptions = {
  width: 5,
  color: 'white',
  size: 160,
  delay: false
}

export default class MaterialSpinner {
  constructor(el, options = {}) {
    this.frame = false
    this.animationFlag = false
    this.options = Object.assign({}, MaterialSpinnerOptions, options)

    this.canvas = el
    this.ctx = this.canvas.getContext('2d')

    this.rotate = 0
    this.i = 0
    this.d = 0

    this.init()
  }

  init() {
    this.animStart()
  }

  destroy() {
    this.animStop()
  }

  render() {
    this.i += 0.02
    this.rotate += 0.1

    const size = this.options.size / 2
    const i = Math.floor(this.i)

    let t = this.i - i
    let t2 = this.i - i

    if (i % 2 === 1) {
      t = 0
    } else {
      t2 = 1
    }

    if (i % 2 === 0 && i > this.d * 2) {
      this.d++
    }

    const y = (t ** 2) / (t ** 2 + Math.pow((1 - t), 2))
    const y2 = (t2 ** 2) / (t2 ** 2 + Math.pow((1 - t2), 2))

    this.ctx.clearRect(0, 0, this.options.size, this.options.size)

    this.ctx.translate(size, size)
    this.ctx.rotate(this.rotate)
    this.ctx.translate(-size, -size)

    this.ctx.beginPath()
    this.ctx.arc(
      size,
      size,
      50,
      (y * 5) + (i * 5) + (this.d * 1.28),
      (y2 * 5) + 0.15 + (i * 5) + (this.d * 1.28)
    )
    this.ctx.lineWidth = this.options.width
    this.ctx.lineCap = 'round'
    this.ctx.strokeStyle = this.options.color
    this.ctx.stroke()

    this.ctx.setTransform(1, 0, 0, 1, 0, 0)
  }

  animUpdate() {
    if (!this.animationFlag) {
      this.render()
      this.frame = window.requestAnimationFrame(this.animUpdate.bind(this))
    }
  }

  animStop() {
    this.animationFlag = true
    if (this.frame) window.cancelAnimationFrame(this.frame)
  }

  animStart() {
    this.animationFlag = false
    if (this.options.delay) {
      setTimeout(() => {
        this.animUpdate()
      }, this.options.delay)
    } else {
      this.animUpdate()
    }
  }
}
